import React from "react";
import ReactMarkdown from "react-markdown";
import { Link } from "react-router-dom";
import rehypeRaw from 'rehype-raw';
import { applyNoWrapMacro } from '../utils/nowrap';

const Markdown = ({ children, className }) => (
  <ReactMarkdown
    className={className}
    rehypePlugins={[rehypeRaw]}
    components={{
      a: ({ href, children }) => <Link to={href}>{children}</Link>,
    }}
  >
    {applyNoWrapMacro(children)}
  </ReactMarkdown>
);

export default Markdown;
